import { LocalizedText, lt } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Dialog, Link, SimpleList, SimpleListItem, Typography } from '@optimus-web/core';

const termsAndConditionsLink = 'https://www.mews.com/en/terms-conditions/card-sharing-functionality';
interface Props {
    active: boolean;
    onClose: () => void;
}
export const TermsAndConditionsDialog = ({ active, onClose }: Props) => (
    <Dialog active={active} onClose={onClose} title={lt('PaymentsConfigurationTermsAndConditionsTitle')}>
        <Typography textStyle="bodyMedium" as="div">
            {lt('PaymentsConfigurationTermsAndConditionsAgreementsLabel')}
        </Typography>
        <SimpleList>
            <SimpleListItem>
                <Typography textStyle="bodyMedium" wordBreak="break-word" as="div">
                    {lt('PaymentsConfigurationTermsAndConditionsShareDataBullet')}
                </Typography>
            </SimpleListItem>
            <SimpleListItem>
                <Typography textStyle="bodyMedium" wordBreak="break-word" as="div">
                    <LocalizedText
                        textKey={TextKey.PaymentsConfigurationTermsAndConditionsAcceptLinkBullet}
                        substitutes={{
                            a: (text) => (
                                <Link href={termsAndConditionsLink} target="_blank" rel="noreferrer">
                                    {text}
                                </Link>
                            ),
                        }}
                    />
                </Typography>
            </SimpleListItem>
            <SimpleListItem>
                <Typography textStyle="bodyMedium" as="div">
                    {lt('PaymentsConfigurationTermsAndConditionsAdminBullet')}
                </Typography>
            </SimpleListItem>
        </SimpleList>
    </Dialog>
);
